import styled, { keyframes } from 'styled-components';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import LoadingAnimation from 'components/loading-animation';
import { LoyaltyNoRewardPoints } from 'pages/loyalty/loyalty-no-reward-points';

import LoyaltyClaimPointsLink from '../loyalty-claim-points/loyalty-claim-points-link';

const slideIn = keyframes`
  from {
    transform: translateY(-12px);
    opacity: 0;
  } to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const RightHeader = styled.div`
  text-align: right;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const LeftHeader = styled.div`
  text-align: left;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const CenterHeader = styled.div`
  text-align: center;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const TableWrap = styled.div<{ idx?: number; bgColor?: string }>`
  position: relative;
  background-color: ${({ bgColor }) => bgColor || Styles.color.white};
  opacity: 0;
  animation: ${slideIn} 0.45s ${({ idx = 0 }) => 0.1 * idx}s forwards;
  border-radius: ${Styles.borderRadius};
  border: 1px solid ${Styles.color.grey.four};
  &:not(:first-of-type) {
    margin-top: 1rem;
  }
  tr {
    margin: 0 1rem;
    & td,
    &:last-of-type td::after {
      border-bottom: none;
    }
    ${Styles.mobile`
      th:first-child,
      td:first-child {
        width: auto;
      }
    `}
  }
  td,
  th {
    font-size: 0.875rem;
    padding: 1rem;
    ${Styles.mobileTiny`
      padding: 1rem 0.25rem;
    `}
    ${Styles.desktop`
      font-size: 1rem;
      padding: 1rem;
    `}
  }
  td {
    position: relative;
    &:first-child {
      padding-left: 1.25rem;
    }
    &:last-child {
      padding-right: 1.25rem;
    }
  }
  td::after {
    content: '';
    position: absolute;
    bottom: 0;
    height: 1px;
    width: 100%;
    border-bottom: 1px solid ${Styles.color.grey.four};
  }
  td:first-child::after,
  td:last-child::after {
    width: calc(100% - 1.25rem);
  }
  td:not(:first-child)::after {
    left: 0;
  }
  td:first-child::after {
    right: 0;
  }
`;

export const StyledLoadingAnimation = styled(LoadingAnimation).attrs(() => ({
  fillColor: Styles.color.primary,
}))`
  margin: 3rem auto;
`;

export const HistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  max-width: 660px;
  padding: 0 1.25rem 2.5rem 1.25rem;
  margin: auto;
  margin-top: 1rem;
  height: 100%;
  background-color: ${Styles.color.background};
`;

export const RefreshContainer = styled.div`
  & > div:first-child {
    min-height: 100vh;
  }
`;

export const TransactionDateAndTime = styled.div`
  font-family: ${Styles.fontFamily.body};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.25rem;
`;

export const TransactionDate = styled.span`
  font-style: normal;
  font-weight: ${Styles.fontWeight.normal};
  font-size: 1rem;
`;

export const TransactionTime = styled.span`
  font-style: ${Styles.fontWeight.normal};
  font-size: 0.875rem;
`;

export const StyledLoyaltyClaimPointsLink = styled(LoyaltyClaimPointsLink)`
  margin: 1rem auto;
  font-size: 0.9rem;
  padding: 0.75rem 1.313rem;
`;

export const StyledPointsIcon = styled(LoyaltyPointsIcon)`
  width: 2rem;
  vertical-align: top;
`;

export const StyledLoyaltyNoRewardPoints = styled(LoyaltyNoRewardPoints)``;
